<mat-card>
    <mat-card-content>
        <mx-object-form (customize)="onCustomize($event)"></mx-object-form>
    </mat-card-content>
    <div class="button">
    <mx-button [buttonModel]="submitButton"></mx-button>
    <mx-button [buttonModel]="cancelButton"></mx-button>
    </div>
</mat-card>
